import { render, staticRenderFns } from "./videoUpload.vue?vue&type=template&id=5e88cde2&scoped=true&"
import script from "./videoUpload.vue?vue&type=script&lang=js&"
export * from "./videoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88cde2",
  null
  
)

export default component.exports